import React, { useEffect, useState, useRef } from "react";
import { useHistory, useParams } from "react-router";
import { ButtonComponent } from "./SubComponents";
import { useDispatch } from "react-redux";
import { editStationFault, clearState } from "../../actions/editStationFault";
import { cloneDeep } from "lodash";
import { useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { services } from "../../api";
import CustomSelect from "./CustomSelect";

export const StatusOption = ["New", "In Progress", "Complete"];
const EditCustomerFault = (props) => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  // const [isFetching, setIsFetching] = useState(false);
  const [fileId, setFileId] = useState(undefined);

  const [editData, setEditData] = useState({
    station_id: "",
    details: "",
    mobile_number: "",
    name: "",
    is_reported_to_staff: "",
    status: " ",
    email: "",
    is_opted_for_update: "",
    station_name: "",
    comments: "",
  });
  const [station, setStation] = useState([]);
  const [isShowStation, setIsShowStation] = useState(false);
  const [searchStation, setSearchStation] = useState("");
  const getStattionList = useSelector(
    (state) => state["CustomerStationFaultsReducer"]
  );
  const saveApiResponse = useSelector((state) => state["editCustomerFault"]);
  const profile = useSelector((state) => state.profileReducer);
  const { loader } = useSelector((state) => state.HeaderReducer);

  const [validationCheck, setValidationCheck] = useState({
    details: false,
    station_name: false,
    status: false,
  });
  const [selectedFile, setSelectedFile] = useState([]);
  const [imageUrl, setImageUrl] = useState("");

  const [activeStation, setActiveStation] = useState(0);
  const nodeInput = useRef(null);

  useEffect(() => {
    if (getStattionList.stationList) {
      setStation(getStattionList.stationList);
    }
  }, [getStattionList]);

  useEffect(() => {
    if (saveApiResponse.successMessage) {
      // setIsFetching(false);
      props.history.push(`/FaultReporter/admin/customerfacilityfault`);
      dispatch(clearState());
    }
  }, [saveApiResponse]);

  useEffect(() => {
    if (history.location.details) {
      let { faultDetail, imgUrl } = history.location.details;

      if (faultDetail) {
        setFileId(faultDetail["File ID"]);

        let editDataTemp = cloneDeep(editData);
        let findStationObj = getStattionList.stationList.find((el, index) => {
          if (el.station_name === faultDetail["Station"]) {
            setActiveStation(index);
            return el;
          }
        });
        editDataTemp.station_name = faultDetail["Station"];
        editDataTemp.station_id = findStationObj
          ? findStationObj.station_id
          : "";
        editDataTemp.details = faultDetail["Details"];
        editDataTemp.mobile_number = faultDetail["Mobile Number"]
          ? faultDetail["Mobile Number"]
          : "";
        editDataTemp.name = faultDetail["Name"] ? faultDetail["Name"] : "";
        editDataTemp.is_reported_to_staff = faultDetail["Reported"];
        editDataTemp.status = faultDetail["Status"];
        editDataTemp.email = faultDetail["Email"] ? faultDetail["Email"] : "";
        editDataTemp.is_opted_for_update = faultDetail["Opted In"];
        setImageUrl(imgUrl);
        // editDataTemp.station_name = faultDetail["Opted In"];
        setEditData(editDataTemp);
      } else {
        history.push(`/FaultReporter/admin/customerfacilityfault`);
      }
    } else {
      history.push(`/FaultReporter/admin/customerfacilityfault`);
    }

    document.addEventListener("mousedown", handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, []);

  const editChangeHandler = ({ currentTarget }) => {
    let editDataTemp = cloneDeep(editData);
    editDataTemp[currentTarget.id] = currentTarget.value;
    setEditData(editDataTemp);
  };

  const stationFilterHandler = ({ currentTarget }) => {
    let stationTemp = cloneDeep(getStattionList.stationList);
    if (currentTarget.value) {
      stationTemp = stationTemp.filter((station) =>
        station.station_name
          .toLowerCase()
          .includes(currentTarget.value.toLowerCase())
      );
      setActiveStation(0);
    }
    setSearchStation(currentTarget.value);
    setStation(stationTemp);
  };

  const showStationsList = () => {
   // setIsShowStation(true);
    setIsShowStation(!isShowStation);
    setActiveStation(activeStation + 0.1);
  };

  const StationClickHandler = (e, _station) => {
    if(_station){
    let editDataTemp = cloneDeep(editData);
    editDataTemp.station_id = _station.station_id;
    editDataTemp.station_name = _station.station_name;
    setActiveStation(_station.station_id-1)
    setEditData(editDataTemp);
    setIsShowStation(false);
    setSearchStation("")
    }
  };

  const handleClick = (e) => {
    if ((e.target.name === "stationSearch") || (e.target.id === "angleDownIcon") ||
     (nodeInput &&
      nodeInput.current &&
      nodeInput.current.contains(e.target))
    ) {
      // inside click
      
      return;
    }
    // outside click

    setIsShowStation(false);
    setStation(getStattionList.stationList);
    setSearchStation("");
  };

  const onClickHandler = (btnType = "") => {
    if (btnType == "back") {
      if (history) {
        history.push({
          pathname: `/FaultReporter/admin/customerfacilityfault/${params.id}/${params.reportId}`,
          details: history.location.details.faultDetail,
        });
      }
    } else if (btnType === "save") {
      let editDataTemp = cloneDeep(editData);
      let validationCheckTemp = cloneDeep(validationCheck);

      Object.keys(validationCheckTemp).forEach((key) => {
        if (!editDataTemp[key]) {
          validationCheckTemp[key] = true;
        } else {
          validationCheckTemp[key] = false;
        }
      });

      setValidationCheck(validationCheckTemp);

      if (
        !Object.keys(validationCheckTemp).some((el) => validationCheckTemp[el])
      ) {
        // setIsFetching(true);
        delete editDataTemp.station_name;
        const formData = new FormData();

        Object.keys(editDataTemp).forEach((key) => {
          if (
            key === "is_reported_to_staff" ||
            key === "is_opted_for_update" ||
            key === "station_id"
          ) {
            formData.append(key, parseInt(editDataTemp[key]));
          } else {
            formData.append(key, editDataTemp[key]);
          }
        });
        if (selectedFile && selectedFile.length) {
          formData.append("file", selectedFile[0]);
        }
        dispatch(
          editStationFault({
            tab: "cff",
            ID: params.id,
            username: profile.fullname,
            formData,
          })
        );
      }
    }
  };

  const fileChangeHandler = (e) => {
    const objectURL = URL.createObjectURL(e.target.files[0]);
    setImageUrl(objectURL);
    setSelectedFile(e.target.files);
  };

  const onChangeFileHandler = () => {
    document.getElementById("my_file").click();
  };

  const onRemoveImgHandler = async () => {
    let res = await services.removeFaultImage(
      `editfault?faultId=${params.id}&tab=cff`,
      "put"
    );
    if (res) {
      setImageUrl("");
      setFileId(undefined);
    }
  };
  const handleScroll = (value) => {
    let ul = document.getElementById("search-list");
    if (ul?.children?.length) {
      var elHeight = ul?.children?.[0]?.offsetHeight;
      var scrollTop = ul?.scrollTop;
      var viewport = scrollTop + ul?.offsetHeight;
      var elOffset = elHeight * value;

      if (elOffset < scrollTop || elOffset + elHeight > viewport) {
        ul.scrollTop = elOffset - elHeight * 7;
      }
    }
  };
  useEffect(() => {
    handleScroll(Math.floor(activeStation));
  }, [activeStation]);
  const onKeyDown = (e) => {
    let stationNo = Math.floor(activeStation);
    if (e.keyCode === 13) {
      e.preventDefault();
      let selectedStation = station[stationNo];
      StationClickHandler(e, selectedStation);
    } else if (e.keyCode === 38) {
      if (stationNo === 0) {
        return;
      }
      //  handleScroll(stationNo - 1);
      setActiveStation(stationNo - 1);
      setSearchStation(station[stationNo - 1]["station_name"]);
    } else if (e.keyCode === 40) {
      if (stationNo < station?.length - 1) {
        //  handleScroll(activeStation + 1);
        setActiveStation(stationNo + 1);
        setSearchStation(station[stationNo + 1]["station_name"]);
      }
    }
  };

  if (loader) {
    return <Loader />;
  }
  return (
    <div className="container-fluid edit-fault-main">
      {/* {loader ? (
        <Loader />
      ) : ( */}
      {/* <> */}
      <h5 className="customer-edit-fault-heading">
        Edit Customer Station Fault
      </h5>
      <div className="customer-edit-fault-header-button-group">
        <ButtonComponent
          title="Back"
          icon="zmdi zmdi-arrow-left"
          onClickHandler={() => onClickHandler("back")}
        />
        <ButtonComponent
          title="Save"
          //  icon="add-fault-icon"
          onClickHandler={() => onClickHandler("save")}
        />
      </div>
      <form className="customer-edit-fault-form">
        <div className="row form-row mb-0 pb-0">
          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group edit-dropdown-select arrow-menu">
              <label className="mandatory">
                Station <span>*</span>
              </label>
              <div className="dropdown station-dropdown dropdownContainer">
                <input
                  onClick={showStationsList}
                  className="form-control"
                  name="stationSearch"
                  value={editData.station_name}
                />
                {isShowStation && (
                  <div id="search-listdiv" ref={nodeInput} className="dropdown-content-div">
                    <input
                      type="text"
                      id="searchInput"
                      placeholder="Search Stations..."
                      className="form-control"
                      autoFocus={true}
                      value={searchStation}
                      onChange={stationFilterHandler}
                      onKeyDown={onKeyDown}
                    />
                    <ul
                      id="search-list"
                      className={`dropdown-content ${
                        isShowStation ? "show" : null
                      }`}
                    >
                      {station.length ? (
                        station.map((station, index) => (
                          <li
                            className={`list-group-item  ${
                              index === Math.floor(activeStation)
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              StationClickHandler(e, station);
                              setActiveStation(index)
                            }}
                            key={index}
                            value={station.station_name}
                          >
                            {station.station_name}
                            {editData.station_name === station.station_name && (
                              <i className="fa fa-check fa-lg"></i>
                            )}
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item" value="">
                           No results matched "{searchStation}"
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>

              <i
                onClick={showStationsList}
                id="angleDownIcon"
                className="fa fa-angle-down dropdownBottomArrow"
              />
            </div>
            {validationCheck.station_name && (
              <div className="msgError help-block">
                <small className="error feedback-error">
                  Please enter fault Station.
                </small>
              </div>
            )}
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label className="mandatory">
                Details <span>*</span>
              </label>
              <input
                type="text"
                id="details"
                className="form-control"
                value={editData.details}
                onChange={editChangeHandler}
              />
              {validationCheck.details && (
                <div className="msgError help-block">
                  <small className="error feedback-error">
                    Please enter fault details.
                  </small>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="text"
                id="mobile_number"
                className="form-control"
                value={editData["mobile_number"]}
                placeholder="Enter Mobile number"
                readOnly
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                id="name"
                className="form-control"
                value={editData["name"]}
                readOnly
                placeholder="Enter Name"
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Reported To Staff</label>
              <input
                type="text"
                id="is_reported_to_staff"
                className="form-control"
                value={
                  editData["is_reported_to_staff"] == "1" ? "true" : "false"
                }
                readOnly
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group edit-dropdown-select">
              <label className="mandatory">
                Status <span>*</span>
              </label>
              <select
                className="form-control fault-status"
                id="status"
                value={editData["status"]}
                onChange={editChangeHandler}
              >
                <option>New</option>
                <option>In Progress</option>
                <option>Complete</option>
              </select>
              {/* <i className="fa fa-angle-down caret-icon"></i> */}
              {validationCheck.status && (
                <div className="msgError help-block">
                  <small className="error feedback-error">
                    Please enter fault Status.
                  </small>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                className="form-control"
                id="email"
                value={editData["email"]}
                readOnly
                placeholder="Enter Email"
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
            <div className="form-group">
              <label className="mandatory">
                Opted For Update <span>*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="Opted In"
                value={
                  editData["is_opted_for_update"] == "1" ? "true" : "false"
                }
                readOnly
              />
            </div>
          </div>

          {editData.status == "Complete" && (
            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div className="form-group">
                <label htmlFor="exampleFormControlTextarea1">Comments</label>
                <textarea
                  className="form-control"
                  id="comments"
                  value={editData.comments}
                  rows="3"
                  onChange={editChangeHandler}
                ></textarea>
              </div>
            </div>
          )}

          <div className="row form-row mb-0 pb-0">
            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div className="form-group after-upload-img">
                <label htmlFor="image">Image Preview</label>

                {imageUrl ? (
                  <>
                    <img
                      className="img-thumbnail img img-preview"
                      src={imageUrl}
                      title="faultImg"
                      alt="fault"
                    />
                    <input
                      type="file"
                      className="edit-image-btn"
                      onChange={fileChangeHandler}
                    />
                  </>
                ) : (
                  <>
                    <div className="img-thumbnail img img-preview edit-image-upload">
                      No image uploaded
                      <input
                        type="file"
                        className="edit-image-btn"
                        onChange={fileChangeHandler}
                      />
                    </div>
                  </>
                )}
              </div>
              <input type="file" id="my_file" onChange={fileChangeHandler} />
            </div>
          </div>
        </div>
      </form>
      {fileId && (
        <ButtonComponent
          title="Remove"
          onClickHandler={onRemoveImgHandler}
          className="btn-remove"
        />
      )}
      <ButtonComponent
        title="Change"
        onClickHandler={onChangeFileHandler}
        className="btn-change"
      />
      {/* </>
      )
      } */}
    </div>
  );
};

export default EditCustomerFault;
